export * from "./Modal";
export * from "./ModalProvider";
export * from "./useModal";
export * from "./types";
export * from "./WorkArea";
export { useModalId } from "@xsolla/xui-core";
